import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AddressType  {
    _originalTypeClassName = "zERP.BO.AddressType";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AddressType.translate = translateService;
}
this.Id = null;
this.Street = null;
this.Number = null;
this.PostalCode = null;
this.City = null;
this.ERPAA = null;
this.ERPDocID = null;
this.IssuerCounterpart = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Street:any;
Number:any;
PostalCode:any;
City:any;
ERPAA:any;
ERPDocID:any;
IssuerCounterpart:any;
ERPInvoiceCategory:any;
ERPInvoiceType:any;
static setERPInvoiceCategory = ($this, value) => {
var oldValue = $this.ERPInvoiceCategory;
$this.ERPInvoiceCategory = value;
if (value != null) {
}
}
static setERPInvoiceType = ($this, value) => {
var oldValue = $this.ERPInvoiceType;
$this.ERPInvoiceType = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}